<template>
    <div class="mg-t-3">
        <b-table
            :data="userList"
            :striped="true"
            :hoverable="true"
            :loading="isLoading"
        >
            <template slot-scope="props">
                <b-table-column field="name" label="ชื่อ-นามสกุล" centered sortable>
                    <div class="has-text-left">
                        <i :class="props.row.activeEmail == 0 ? 'has-text-grey-light' : 'has-text-primary' " class="fas fa-check-circle is-inline-block mg-r-3 mg-l-2"></i>
                        <p class="text-left is-inline-block">{{ props.row.name }} {{ props.row.surname }}</p>
                    </div>
                </b-table-column>
                <b-table-column field="department" label="อีเมล" centered sortable>
                    {{ props.row.email }}
                </b-table-column>
                <b-table-column field="position" label="สังกัดหน่วยงาน" centered sortable>
                    {{ props.row.department }}
                </b-table-column>

               
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>ขณะนี้ยังไม่มีข้อมูล</p>
                    </div>
                </section>
            </template>
        </b-table>

        <b-modal :active.sync="isModalFormActive" :width="700" @close="fetchUserAdminAceForm">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">กรุณาเลือกฟอร์ม</p>
                </header>
                <section class="modal-card-body"> 
                    <div v-for="item in formList" :key="item._id" class="field">
                        <b-checkbox v-model="formCheck" @input="checkAcotionForm(item._id)" :native-value="item._id">{{item.name}}</b-checkbox>
                    </div> 
                </section>
                <footer class="modal-card-foot js-end"></footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DefaultTemplate from '@/template/DefaultTemplate'
import { HTTP } from "@/service/axios.js";
import {
    alertFailError,
    alertCatchError
} from "@/service/alert";

export default {
    components:{
        DefaultTemplate
    },
    data() {
        return {
            userList:[],
            formList:[],
            isModalFormActive:false,
            formCheck:[],
            userId:'',
            isLoading:false
        }
    },
    computed: {
        user(){
            return this.$store.state.user
        }
    },
    mounted() {
        this.isLoading = true
        this.fetchUserAdminAceForm()
        this.fetchFormList()
    },
    methods: {
        openModalForm(data){
            this.isModalFormActive = true
            this.userId = data._id
            
            let form = []
            data.form.map((item)=>{
                form.push(item.formId)
            })

            this.formCheck = form
        },
        fetchUserAdminAceForm(){
            HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            HTTP.get('admin/ace/form').then(res=>{
                if(res.data.success){
                    this.userList = res.data.obj.filter(filter => filter.userLevel == 50)
                }else{
                    this.userList = []
                }
            }).catch(e => {
                console.log('fetchUserAdminAceForm error', e)
            }).finally(()=>{
                this.isLoading = false
            })
        },
        fetchFormList(){

            HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            HTTP.get('forms').then(res=>{
                if(res.data.success){
                    this.formList = res.data.obj.obj.form
                }else{
                    this.formList = []
                }
            }).catch(e => {
                console.log('fetchFormList error', e)
            })
        },
        checkAcotionForm(id){
            let filter = this.formCheck.filter(filter => filter == id) 
            if (filter.length > 0) {
                this.assignForm(id)
            } else {
                this.unassignForm(id)
            }
        },
        assignForm(id){
            let obj={
                userId:this.userId
            }

            HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            HTTP.put(`assign/${id}`,obj).then(res=>{

                if(!res.data.success){
                    this.alertFailError()
                    let filter = this.formCheck.filter(filter => filter !== id)
                    this.formCheck = filter
                }
            }).catch(e => {
                this.alertCatchError()
                console.log('assignForm error', e)
            })
        },
        unassignForm(id){
            let obj={
                userId:this.userId
            }

            HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            HTTP.put(`unassign/${id}`,obj).then(res=>{
                console.log('unassignForm',res)
                if(!res.data.success){
                    this.alertFailError()
                    this.formCheck.push(id)
                }
            }).catch(e => {
                this.alertCatchError()
                console.log('unassignForm error', e)
            })
        },
        getNameForm(id){
           let filter = this.formList.filter(filter => filter._id == id)
           if (filter.length > 0) {
               return filter[0].name
           }else{
               return ''
           }
        }
    },
}
</script>

<style scoped>
    .waitBox{
        min-height: 450px;
        padding: 120px;
    }
    .maxWord{
        max-width: 400px;
    }
</style>